import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AdminRoute } from "./components/AdminRoute";
import { Footer } from "./components/Footer";
import { TopBar } from "./components/TopBar";
import { PreviewBar } from "./components/PreviewBar";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CoursePage } from "./pages/CoursePage";
import { LessonPage } from "./pages/LessonPage";
import { ProfilePage } from "./pages/ProfilePage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { TermsPage } from "./pages/TermsPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ActiveTimer, CommunityGate } from "./components/CommunityGate";
import { WelcomePage } from "./pages/WelcomePage";
import { CommunityPage } from "./pages/CommunityPage";
import { CommunityPostPage } from "./pages/CommunityPostPage";
import { LeaderboardPage } from "./pages/LeaderboardPage";
import { HomeworkPage } from "./pages/HomeworkPage";
import { JourneyPage } from "./pages/JourneyPage";
import { CertificatePage } from "./pages/CertificatePage";

// Admin-only screens: kept out of the bundle every student downloads.
const AdminPage = lazy(() => import("./pages/AdminPage").then((m) => ({ default: m.AdminPage })));
const AdminStudentsPage = lazy(() => import("./pages/admin/AdminStudentsPage").then((m) => ({ default: m.AdminStudentsPage })));
const AdminProgressPage = lazy(() => import("./pages/admin/AdminProgressPage").then((m) => ({ default: m.AdminProgressPage })));
const AdminHomeworkPage = lazy(() => import("./pages/admin/AdminHomeworkPage").then((m) => ({ default: m.AdminHomeworkPage })));
const AdminCheckinsPage = lazy(() => import("./pages/admin/AdminCheckinsPage").then((m) => ({ default: m.AdminCheckinsPage })));

export function App() {
  return (
    <AuthProvider>
      <TopBar />
      <ActiveTimer />
      <Suspense fallback={<p style={{ padding: "3rem", color: "var(--c-text-muted)" }}>กำลังโหลด…</p>}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Public on purpose: anyone with the link can verify a certificate. */}
        <Route path="/cert/:id" element={<CertificatePage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/courses/:courseId" element={<CoursePage />} />
          <Route path="/courses/:courseId/lessons/:lessonId" element={<LessonPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/homework" element={<HomeworkPage />} />
          <Route path="/journey" element={<JourneyPage />} />
          <Route element={<CommunityGate />}>
            <Route path="/chat" element={<CommunityPage />} />
            <Route path="/chat/:postId" element={<CommunityPostPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
          </Route>
        </Route>

        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/students" element={<AdminStudentsPage />} />
          <Route path="/admin/progress" element={<AdminProgressPage />} />
          <Route path="/admin/checkins" element={<AdminCheckinsPage />} />
          <Route path="/admin/homework" element={<AdminHomeworkPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </Suspense>
      <Footer />
      <PreviewBar />
    </AuthProvider>
  );
}
